import React, { useCallback, useEffect, useRef, useState } from 'react'

import NavigationPopup from './NavigationPopup'

function NavigationItem({
  className,
  content,
  setOnClickCallback,
  setBadgeCount,
  width,
  onCloseCallback,
}) {
  const wrapperRef = useRef(null)
  const [showModal, toggleModal] = useState(false)

  const togglePopup = () => toggleModal(!showModal)

  const hideModal = useCallback(() => {
    toggleModal(false)
  }, [])

  useEffect(() => {
    if (!showModal) {
      onCloseCallback()
    }
  }, [showModal, onCloseCallback])

  const handlerOutsideClick = useCallback(
    (e) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(e.target) &&
        e.target.className.indexOf('bell') === -1 &&
        e.target.className.indexOf('bell-badge') === -1
      ) {
        hideModal()
      }
    },
    [wrapperRef]
  )

  useEffect(() => {
    setOnClickCallback(togglePopup)
    if (setBadgeCount) setBadgeCount()

    window.addEventListener('mousedown', handlerOutsideClick)

    return () => window.removeEventListener('mousedown', handlerOutsideClick)
  }, [])

  return (
    <>
      {showModal && (
        <NavigationPopup ref={wrapperRef} className={className} width={width}>
          <div className="content" onClick={togglePopup}>
            {content}
          </div>
        </NavigationPopup>
      )}
    </>
  )
}

export default NavigationItem
